import {AfterViewInit, Directive, ElementRef} from '@angular/core';

@Directive({
    standalone: false,
    selector: '[nameShortFormat]'
})
export class NameEllipseDirective implements AfterViewInit {

  constructor(private elementRef: ElementRef) {
  }

  ngAfterViewInit() {
    const element = this.elementRef.nativeElement;
    let innerText = element.innerText;
    if (innerText.length > 14) {
      innerText = `${innerText.substr(0, 14)}...`;
    }
    element.innerText = innerText;
  }
}
